import { default as indexTvHDTJQ1P2Meta } from "/opt/apps/transkribus_app_beta/pages/activity/advanced/index.vue?macro=true";
import { default as indexz7Fjlb0cdlMeta } from "/opt/apps/transkribus_app_beta/pages/activity/all/index.vue?macro=true";
import { default as indexJAiNo3QqvRMeta } from "/opt/apps/transkribus_app_beta/pages/activity/orchestrator/index.vue?macro=true";
import { default as indexXbLvg0J41cMeta } from "/opt/apps/transkribus_app_beta/pages/activity/recognition/index.vue?macro=true";
import { default as indexrFdGiRsgjeMeta } from "/opt/apps/transkribus_app_beta/pages/activity/up-download/index.vue?macro=true";
import { default as buildpXLoyWjP39Meta } from "/opt/apps/transkribus_app_beta/pages/build.vue?macro=true";
import { default as changelogtSbwX5sUuBMeta } from "/opt/apps/transkribus_app_beta/pages/changelog.vue?macro=true";
import { default as index6eLAzBwW77Meta } from "/opt/apps/transkribus_app_beta/pages/collection-settings/index.vue?macro=true";
import { default as indexJtDug8AcVKMeta } from "/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/detail/[pageid]/index.vue?macro=true";
import { default as indexbNZXe4A4ZlMeta } from "/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/edit/[pageid]/index.vue?macro=true";
import { default as indextrQtpBnygjMeta } from "/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/edit/index.vue?macro=true";
import { default as indexBIzaJQOYbQMeta } from "/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/index.vue?macro=true";
import { default as indexaTUPfFYml4Meta } from "/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/index.vue?macro=true";
import { default as index5q087hwQCsMeta } from "/opt/apps/transkribus_app_beta/pages/collection/index.vue?macro=true";
import { default as index4cY8iBMiJWMeta } from "/opt/apps/transkribus_app_beta/pages/data-lab/index.vue?macro=true";
import { default as indexLBiA32TTSTMeta } from "/opt/apps/transkribus_app_beta/pages/data-lab/train/index.vue?macro=true";
import { default as indexdNivv5MaGVMeta } from "/opt/apps/transkribus_app_beta/pages/datasets/[id]/index.vue?macro=true";
import { default as indexVZVKP9ks0VMeta } from "/opt/apps/transkribus_app_beta/pages/datasets/[id]/manage/index.vue?macro=true";
import { default as indexaYd9RzQi2WMeta } from "/opt/apps/transkribus_app_beta/pages/datasets/create/index.vue?macro=true";
import { default as indexkl1pqCAtCJMeta } from "/opt/apps/transkribus_app_beta/pages/datasets/index.vue?macro=true";
import { default as guideT5fBplre3KMeta } from "/opt/apps/transkribus_app_beta/pages/guide.vue?macro=true";
import { default as index0iDStHhf3oMeta } from "/opt/apps/transkribus_app_beta/pages/index.vue?macro=true";
import { default as indexPtJOiT2qphMeta } from "/opt/apps/transkribus_app_beta/pages/invitations/[inviteid]/index.vue?macro=true";
import { default as index0Hm5PEMkWYMeta } from "/opt/apps/transkribus_app_beta/pages/invitations/index.vue?macro=true";
import { default as indexmkpByaHvHiMeta } from "/opt/apps/transkribus_app_beta/pages/jobs/index.vue?macro=true";
import { default as indexgkVCCvbf3iMeta } from "/opt/apps/transkribus_app_beta/pages/learn/index.vue?macro=true";
import { default as loginbRZpbbjm0sMeta } from "/opt/apps/transkribus_app_beta/pages/login.vue?macro=true";
import { default as index7mV0dKxk3mMeta } from "/opt/apps/transkribus_app_beta/pages/models/[type]/[modelId]/index.vue?macro=true";
import { default as indexdPq7FVrEgNMeta } from "/opt/apps/transkribus_app_beta/pages/models/[type]/[modelId]/modify/index.vue?macro=true";
import { default as indexkENBoaFsyRMeta } from "/opt/apps/transkribus_app_beta/pages/models/[type]/[modelId]/train-data/index.vue?macro=true";
import { default as indexC01RUBKaPgMeta } from "/opt/apps/transkribus_app_beta/pages/models/index.vue?macro=true";
import { default as indexgG8L5LmOhnMeta } from "/opt/apps/transkribus_app_beta/pages/models/public/[type]/[modelId]/index.vue?macro=true";
import { default as indexaKAzoaOrTRMeta } from "/opt/apps/transkribus_app_beta/pages/models/public/index.vue?macro=true";
import { default as indexV5CAEl45tWMeta } from "/opt/apps/transkribus_app_beta/pages/notifications/index.vue?macro=true";
import { default as index19A1Fi56UAMeta } from "/opt/apps/transkribus_app_beta/pages/public-models/index.vue?macro=true";
import { default as indexPFNk7cVCDdMeta } from "/opt/apps/transkribus_app_beta/pages/quality-control/index.vue?macro=true";
import { default as indexA8QQJcAAdtMeta } from "/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/index.vue?macro=true";
import { default as indexbU4LoJV0KNMeta } from "/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/page/[pageid]/index.vue?macro=true";
import { default as indexK3FXwhIcXCMeta } from "/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/results/index.vue?macro=true";
import { default as index1KcekeGShBMeta } from "/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/index.vue?macro=true";
import { default as indexlIThFulaxmMeta } from "/opt/apps/transkribus_app_beta/pages/search/index.vue?macro=true";
import { default as indexdGNUadrFV9Meta } from "/opt/apps/transkribus_app_beta/pages/share/[hash]/index.vue?macro=true";
import { default as indexfXQ4E4yOBLMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/about/index.vue?macro=true";
import { default as indexsV2aYJqX7tMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/browse/index.vue?macro=true";
import { default as indexJ6Jg80OvjpMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/content/[contentName]/index.vue?macro=true";
import { default as indexb3Cm1Q0hn5Meta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/doc/[docid]/detail/[pageid]/index.vue?macro=true";
import { default as indexnb4OrYTux5Meta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/doc/[docid]/detail/index.vue?macro=true";
import { default as indexybJBRdbvVWMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/doc/[docid]/index.vue?macro=true";
import { default as index2F7xGWDl3oMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/imprint/index.vue?macro=true";
import { default as indexKR4rDOoNGFMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/index.vue?macro=true";
import { default as indexqOV5qkiA0hMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/search/index.vue?macro=true";
import { default as indexJtYT9fGwcEMeta } from "/opt/apps/transkribus_app_beta/pages/sites/[url]/tags/index.vue?macro=true";
import { default as indexEcTSAQcYmUMeta } from "/opt/apps/transkribus_app_beta/pages/sites/index.vue?macro=true";
import { default as indexGwvY6exWwOMeta } from "/opt/apps/transkribus_app_beta/pages/upload/index.vue?macro=true";
import { default as index3DnPB0LYycMeta } from "/opt/apps/transkribus_app_beta/pages/usage/index.vue?macro=true";
import { default as indexhzrrHczR6qMeta } from "/opt/apps/transkribus_app_beta/pages/usage/manage-organisation/[organisationid]/index.vue?macro=true";
import { default as indexpTpkqhTGyWMeta } from "/opt/apps/transkribus_app_beta/pages/user-settings/index.vue?macro=true";
import { default as indexBvnfDRJevdMeta } from "/opt/apps/transkribus_app_beta/pages/version/index.vue?macro=true";
import { default as indexeP88q9sA34Meta } from "/opt/apps/transkribus_app_beta/pages/welcome/index.vue?macro=true";
import { default as component_45stubBMljg2BvY4Meta } from "/opt/apps/transkribus_app_beta/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stubBMljg2BvY4 } from "/opt/apps/transkribus_app_beta/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: indexTvHDTJQ1P2Meta?.name ?? "activity-advanced",
    path: indexTvHDTJQ1P2Meta?.path ?? "/activity/advanced",
    meta: indexTvHDTJQ1P2Meta || {},
    alias: indexTvHDTJQ1P2Meta?.alias || [],
    redirect: indexTvHDTJQ1P2Meta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/activity/advanced/index.vue").then(m => m.default || m)
  },
  {
    name: indexz7Fjlb0cdlMeta?.name ?? "activity-all",
    path: indexz7Fjlb0cdlMeta?.path ?? "/activity/all",
    meta: indexz7Fjlb0cdlMeta || {},
    alias: indexz7Fjlb0cdlMeta?.alias || [],
    redirect: indexz7Fjlb0cdlMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/activity/all/index.vue").then(m => m.default || m)
  },
  {
    name: indexJAiNo3QqvRMeta?.name ?? "activity-orchestrator",
    path: indexJAiNo3QqvRMeta?.path ?? "/activity/orchestrator",
    meta: indexJAiNo3QqvRMeta || {},
    alias: indexJAiNo3QqvRMeta?.alias || [],
    redirect: indexJAiNo3QqvRMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/activity/orchestrator/index.vue").then(m => m.default || m)
  },
  {
    name: indexXbLvg0J41cMeta?.name ?? "activity-recognition",
    path: indexXbLvg0J41cMeta?.path ?? "/activity/recognition",
    meta: indexXbLvg0J41cMeta || {},
    alias: indexXbLvg0J41cMeta?.alias || [],
    redirect: indexXbLvg0J41cMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/activity/recognition/index.vue").then(m => m.default || m)
  },
  {
    name: indexrFdGiRsgjeMeta?.name ?? "activity-up-download",
    path: indexrFdGiRsgjeMeta?.path ?? "/activity/up-download",
    meta: indexrFdGiRsgjeMeta || {},
    alias: indexrFdGiRsgjeMeta?.alias || [],
    redirect: indexrFdGiRsgjeMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/activity/up-download/index.vue").then(m => m.default || m)
  },
  {
    name: buildpXLoyWjP39Meta?.name ?? "build",
    path: buildpXLoyWjP39Meta?.path ?? "/build",
    meta: buildpXLoyWjP39Meta || {},
    alias: buildpXLoyWjP39Meta?.alias || [],
    redirect: buildpXLoyWjP39Meta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/build.vue").then(m => m.default || m)
  },
  {
    name: changelogtSbwX5sUuBMeta?.name ?? "changelog",
    path: changelogtSbwX5sUuBMeta?.path ?? "/changelog",
    meta: changelogtSbwX5sUuBMeta || {},
    alias: changelogtSbwX5sUuBMeta?.alias || [],
    redirect: changelogtSbwX5sUuBMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/changelog.vue").then(m => m.default || m)
  },
  {
    name: index6eLAzBwW77Meta?.name ?? "collection-settings",
    path: index6eLAzBwW77Meta?.path ?? "/collection-settings",
    meta: index6eLAzBwW77Meta || {},
    alias: index6eLAzBwW77Meta?.alias || [],
    redirect: index6eLAzBwW77Meta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexJtDug8AcVKMeta?.name ?? "collection-collectionid-doc-docid-detail-pageid",
    path: indexJtDug8AcVKMeta?.path ?? "/collection/:collectionid()/doc/:docid()/detail/:pageid()",
    meta: indexJtDug8AcVKMeta || {},
    alias: indexJtDug8AcVKMeta?.alias || [],
    redirect: indexJtDug8AcVKMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/detail/[pageid]/index.vue").then(m => m.default || m)
  },
  {
    name: indexbNZXe4A4ZlMeta?.name ?? "collection-collectionid-doc-docid-edit-pageid",
    path: indexbNZXe4A4ZlMeta?.path ?? "/collection/:collectionid()/doc/:docid()/edit/:pageid()",
    meta: indexbNZXe4A4ZlMeta || {},
    alias: indexbNZXe4A4ZlMeta?.alias || [],
    redirect: indexbNZXe4A4ZlMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/edit/[pageid]/index.vue").then(m => m.default || m)
  },
  {
    name: indextrQtpBnygjMeta?.name ?? "collection-collectionid-doc-docid-edit",
    path: indextrQtpBnygjMeta?.path ?? "/collection/:collectionid()/doc/:docid()/edit",
    meta: indextrQtpBnygjMeta || {},
    alias: indextrQtpBnygjMeta?.alias || [],
    redirect: indextrQtpBnygjMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/edit/index.vue").then(m => m.default || m)
  },
  {
    name: indexBIzaJQOYbQMeta?.name ?? "collection-collectionid-doc-docid",
    path: indexBIzaJQOYbQMeta?.path ?? "/collection/:collectionid()/doc/:docid()",
    meta: indexBIzaJQOYbQMeta || {},
    alias: indexBIzaJQOYbQMeta?.alias || [],
    redirect: indexBIzaJQOYbQMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/doc/[docid]/index.vue").then(m => m.default || m)
  },
  {
    name: indexaTUPfFYml4Meta?.name ?? "collection-collectionid",
    path: indexaTUPfFYml4Meta?.path ?? "/collection/:collectionid()",
    meta: indexaTUPfFYml4Meta || {},
    alias: indexaTUPfFYml4Meta?.alias || [],
    redirect: indexaTUPfFYml4Meta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection/[collectionid]/index.vue").then(m => m.default || m)
  },
  {
    name: index5q087hwQCsMeta?.name ?? "collection",
    path: index5q087hwQCsMeta?.path ?? "/collection",
    meta: index5q087hwQCsMeta || {},
    alias: index5q087hwQCsMeta?.alias || [],
    redirect: index5q087hwQCsMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/collection/index.vue").then(m => m.default || m)
  },
  {
    name: index4cY8iBMiJWMeta?.name ?? "data-lab",
    path: index4cY8iBMiJWMeta?.path ?? "/data-lab",
    meta: index4cY8iBMiJWMeta || {},
    alias: index4cY8iBMiJWMeta?.alias || [],
    redirect: index4cY8iBMiJWMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/data-lab/index.vue").then(m => m.default || m)
  },
  {
    name: indexLBiA32TTSTMeta?.name ?? "data-lab-train",
    path: indexLBiA32TTSTMeta?.path ?? "/data-lab/train",
    meta: indexLBiA32TTSTMeta || {},
    alias: indexLBiA32TTSTMeta?.alias || [],
    redirect: indexLBiA32TTSTMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/data-lab/train/index.vue").then(m => m.default || m)
  },
  {
    name: indexdNivv5MaGVMeta?.name ?? "datasets-id",
    path: indexdNivv5MaGVMeta?.path ?? "/datasets/:id()",
    meta: indexdNivv5MaGVMeta || {},
    alias: indexdNivv5MaGVMeta?.alias || [],
    redirect: indexdNivv5MaGVMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/datasets/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexVZVKP9ks0VMeta?.name ?? "datasets-id-manage",
    path: indexVZVKP9ks0VMeta?.path ?? "/datasets/:id()/manage",
    meta: indexVZVKP9ks0VMeta || {},
    alias: indexVZVKP9ks0VMeta?.alias || [],
    redirect: indexVZVKP9ks0VMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/datasets/[id]/manage/index.vue").then(m => m.default || m)
  },
  {
    name: indexaYd9RzQi2WMeta?.name ?? "datasets-create",
    path: indexaYd9RzQi2WMeta?.path ?? "/datasets/create",
    meta: indexaYd9RzQi2WMeta || {},
    alias: indexaYd9RzQi2WMeta?.alias || [],
    redirect: indexaYd9RzQi2WMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/datasets/create/index.vue").then(m => m.default || m)
  },
  {
    name: indexkl1pqCAtCJMeta?.name ?? "datasets",
    path: indexkl1pqCAtCJMeta?.path ?? "/datasets",
    meta: indexkl1pqCAtCJMeta || {},
    alias: indexkl1pqCAtCJMeta?.alias || [],
    redirect: indexkl1pqCAtCJMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/datasets/index.vue").then(m => m.default || m)
  },
  {
    name: guideT5fBplre3KMeta?.name ?? "guide",
    path: guideT5fBplre3KMeta?.path ?? "/guide",
    meta: guideT5fBplre3KMeta || {},
    alias: guideT5fBplre3KMeta?.alias || [],
    redirect: guideT5fBplre3KMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/guide.vue").then(m => m.default || m)
  },
  {
    name: index0iDStHhf3oMeta?.name ?? "index",
    path: index0iDStHhf3oMeta?.path ?? "/",
    meta: index0iDStHhf3oMeta || {},
    alias: index0iDStHhf3oMeta?.alias || [],
    redirect: index0iDStHhf3oMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexPtJOiT2qphMeta?.name ?? "invitations-inviteid",
    path: indexPtJOiT2qphMeta?.path ?? "/invitations/:inviteid()",
    meta: indexPtJOiT2qphMeta || {},
    alias: indexPtJOiT2qphMeta?.alias || [],
    redirect: indexPtJOiT2qphMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/invitations/[inviteid]/index.vue").then(m => m.default || m)
  },
  {
    name: index0Hm5PEMkWYMeta?.name ?? "invitations",
    path: index0Hm5PEMkWYMeta?.path ?? "/invitations",
    meta: index0Hm5PEMkWYMeta || {},
    alias: index0Hm5PEMkWYMeta?.alias || [],
    redirect: index0Hm5PEMkWYMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/invitations/index.vue").then(m => m.default || m)
  },
  {
    name: indexmkpByaHvHiMeta?.name ?? "jobs",
    path: indexmkpByaHvHiMeta?.path ?? "/jobs",
    meta: indexmkpByaHvHiMeta || {},
    alias: indexmkpByaHvHiMeta?.alias || [],
    redirect: indexmkpByaHvHiMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/jobs/index.vue").then(m => m.default || m)
  },
  {
    name: indexgkVCCvbf3iMeta?.name ?? "learn",
    path: indexgkVCCvbf3iMeta?.path ?? "/learn",
    meta: indexgkVCCvbf3iMeta || {},
    alias: indexgkVCCvbf3iMeta?.alias || [],
    redirect: indexgkVCCvbf3iMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/learn/index.vue").then(m => m.default || m)
  },
  {
    name: loginbRZpbbjm0sMeta?.name ?? "login",
    path: loginbRZpbbjm0sMeta?.path ?? "/login",
    meta: loginbRZpbbjm0sMeta || {},
    alias: loginbRZpbbjm0sMeta?.alias || [],
    redirect: loginbRZpbbjm0sMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/login.vue").then(m => m.default || m)
  },
  {
    name: index7mV0dKxk3mMeta?.name ?? "models-type-modelId",
    path: index7mV0dKxk3mMeta?.path ?? "/models/:type()/:modelId()",
    meta: index7mV0dKxk3mMeta || {},
    alias: index7mV0dKxk3mMeta?.alias || [],
    redirect: index7mV0dKxk3mMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/models/[type]/[modelId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexdPq7FVrEgNMeta?.name ?? "models-type-modelId-modify",
    path: indexdPq7FVrEgNMeta?.path ?? "/models/:type()/:modelId()/modify",
    meta: indexdPq7FVrEgNMeta || {},
    alias: indexdPq7FVrEgNMeta?.alias || [],
    redirect: indexdPq7FVrEgNMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/models/[type]/[modelId]/modify/index.vue").then(m => m.default || m)
  },
  {
    name: indexkENBoaFsyRMeta?.name ?? "models-type-modelId-train-data",
    path: indexkENBoaFsyRMeta?.path ?? "/models/:type()/:modelId()/train-data",
    meta: indexkENBoaFsyRMeta || {},
    alias: indexkENBoaFsyRMeta?.alias || [],
    redirect: indexkENBoaFsyRMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/models/[type]/[modelId]/train-data/index.vue").then(m => m.default || m)
  },
  {
    name: indexC01RUBKaPgMeta?.name ?? "models",
    path: indexC01RUBKaPgMeta?.path ?? "/models",
    meta: indexC01RUBKaPgMeta || {},
    alias: indexC01RUBKaPgMeta?.alias || [],
    redirect: indexC01RUBKaPgMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/models/index.vue").then(m => m.default || m)
  },
  {
    name: indexgG8L5LmOhnMeta?.name ?? "models-public-type-modelId",
    path: indexgG8L5LmOhnMeta?.path ?? "/models/public/:type()/:modelId()",
    meta: indexgG8L5LmOhnMeta || {},
    alias: indexgG8L5LmOhnMeta?.alias || [],
    redirect: indexgG8L5LmOhnMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/models/public/[type]/[modelId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexaKAzoaOrTRMeta?.name ?? "models-public",
    path: indexaKAzoaOrTRMeta?.path ?? "/models/public",
    meta: indexaKAzoaOrTRMeta || {},
    alias: indexaKAzoaOrTRMeta?.alias || [],
    redirect: indexaKAzoaOrTRMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/models/public/index.vue").then(m => m.default || m)
  },
  {
    name: indexV5CAEl45tWMeta?.name ?? "notifications",
    path: indexV5CAEl45tWMeta?.path ?? "/notifications",
    meta: indexV5CAEl45tWMeta || {},
    alias: indexV5CAEl45tWMeta?.alias || [],
    redirect: indexV5CAEl45tWMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/notifications/index.vue").then(m => m.default || m)
  },
  {
    name: index19A1Fi56UAMeta?.name ?? "public-models",
    path: index19A1Fi56UAMeta?.path ?? "/public-models",
    meta: index19A1Fi56UAMeta || {},
    alias: index19A1Fi56UAMeta?.alias || [],
    redirect: index19A1Fi56UAMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/public-models/index.vue").then(m => m.default || m)
  },
  {
    name: indexPFNk7cVCDdMeta?.name ?? "quality-control",
    path: indexPFNk7cVCDdMeta?.path ?? "/quality-control",
    meta: indexPFNk7cVCDdMeta || {},
    alias: indexPFNk7cVCDdMeta?.alias || [],
    redirect: indexPFNk7cVCDdMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/quality-control/index.vue").then(m => m.default || m)
  },
  {
    name: indexA8QQJcAAdtMeta?.name ?? "quality-control-sample-sampleid-evaluation-evaluationid",
    path: indexA8QQJcAAdtMeta?.path ?? "/quality-control/sample/:sampleid()/evaluation/:evaluationid()",
    meta: indexA8QQJcAAdtMeta || {},
    alias: indexA8QQJcAAdtMeta?.alias || [],
    redirect: indexA8QQJcAAdtMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/index.vue").then(m => m.default || m)
  },
  {
    name: indexbU4LoJV0KNMeta?.name ?? "quality-control-sample-sampleid-evaluation-evaluationid-page-pageid",
    path: indexbU4LoJV0KNMeta?.path ?? "/quality-control/sample/:sampleid()/evaluation/:evaluationid()/page/:pageid()",
    meta: indexbU4LoJV0KNMeta || {},
    alias: indexbU4LoJV0KNMeta?.alias || [],
    redirect: indexbU4LoJV0KNMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/page/[pageid]/index.vue").then(m => m.default || m)
  },
  {
    name: indexK3FXwhIcXCMeta?.name ?? "quality-control-sample-sampleid-evaluation-evaluationid-results",
    path: indexK3FXwhIcXCMeta?.path ?? "/quality-control/sample/:sampleid()/evaluation/:evaluationid()/results",
    meta: indexK3FXwhIcXCMeta || {},
    alias: indexK3FXwhIcXCMeta?.alias || [],
    redirect: indexK3FXwhIcXCMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/evaluation/[evaluationid]/results/index.vue").then(m => m.default || m)
  },
  {
    name: index1KcekeGShBMeta?.name ?? "quality-control-sample-sampleid",
    path: index1KcekeGShBMeta?.path ?? "/quality-control/sample/:sampleid()",
    meta: index1KcekeGShBMeta || {},
    alias: index1KcekeGShBMeta?.alias || [],
    redirect: index1KcekeGShBMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/quality-control/sample/[sampleid]/index.vue").then(m => m.default || m)
  },
  {
    name: indexlIThFulaxmMeta?.name ?? "search",
    path: indexlIThFulaxmMeta?.path ?? "/search",
    meta: indexlIThFulaxmMeta || {},
    alias: indexlIThFulaxmMeta?.alias || [],
    redirect: indexlIThFulaxmMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexdGNUadrFV9Meta?.name ?? "share-hash",
    path: indexdGNUadrFV9Meta?.path ?? "/share/:hash()",
    meta: indexdGNUadrFV9Meta || {},
    alias: indexdGNUadrFV9Meta?.alias || [],
    redirect: indexdGNUadrFV9Meta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/share/[hash]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfXQ4E4yOBLMeta?.name ?? "sites-url-about",
    path: indexfXQ4E4yOBLMeta?.path ?? "/sites/:url()/about",
    meta: indexfXQ4E4yOBLMeta || {},
    alias: indexfXQ4E4yOBLMeta?.alias || [],
    redirect: indexfXQ4E4yOBLMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/about/index.vue").then(m => m.default || m)
  },
  {
    name: indexsV2aYJqX7tMeta?.name ?? "sites-url-browse",
    path: indexsV2aYJqX7tMeta?.path ?? "/sites/:url()/browse",
    meta: indexsV2aYJqX7tMeta || {},
    alias: indexsV2aYJqX7tMeta?.alias || [],
    redirect: indexsV2aYJqX7tMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/browse/index.vue").then(m => m.default || m)
  },
  {
    name: indexJ6Jg80OvjpMeta?.name ?? "sites-url-content-contentName",
    path: indexJ6Jg80OvjpMeta?.path ?? "/sites/:url()/content/:contentName()",
    meta: indexJ6Jg80OvjpMeta || {},
    alias: indexJ6Jg80OvjpMeta?.alias || [],
    redirect: indexJ6Jg80OvjpMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/content/[contentName]/index.vue").then(m => m.default || m)
  },
  {
    name: indexb3Cm1Q0hn5Meta?.name ?? "sites-url-doc-docid-detail-pageid",
    path: indexb3Cm1Q0hn5Meta?.path ?? "/sites/:url()/doc/:docid()/detail/:pageid()",
    meta: indexb3Cm1Q0hn5Meta || {},
    alias: indexb3Cm1Q0hn5Meta?.alias || [],
    redirect: indexb3Cm1Q0hn5Meta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/doc/[docid]/detail/[pageid]/index.vue").then(m => m.default || m)
  },
  {
    name: indexnb4OrYTux5Meta?.name ?? "sites-url-doc-docid-detail",
    path: indexnb4OrYTux5Meta?.path ?? "/sites/:url()/doc/:docid()/detail",
    meta: indexnb4OrYTux5Meta || {},
    alias: indexnb4OrYTux5Meta?.alias || [],
    redirect: indexnb4OrYTux5Meta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/doc/[docid]/detail/index.vue").then(m => m.default || m)
  },
  {
    name: indexybJBRdbvVWMeta?.name ?? "sites-url-doc-docid",
    path: indexybJBRdbvVWMeta?.path ?? "/sites/:url()/doc/:docid()",
    meta: indexybJBRdbvVWMeta || {},
    alias: indexybJBRdbvVWMeta?.alias || [],
    redirect: indexybJBRdbvVWMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/doc/[docid]/index.vue").then(m => m.default || m)
  },
  {
    name: index2F7xGWDl3oMeta?.name ?? "sites-url-imprint",
    path: index2F7xGWDl3oMeta?.path ?? "/sites/:url()/imprint",
    meta: index2F7xGWDl3oMeta || {},
    alias: index2F7xGWDl3oMeta?.alias || [],
    redirect: index2F7xGWDl3oMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/imprint/index.vue").then(m => m.default || m)
  },
  {
    name: indexKR4rDOoNGFMeta?.name ?? "sites-url",
    path: indexKR4rDOoNGFMeta?.path ?? "/sites/:url()",
    meta: indexKR4rDOoNGFMeta || {},
    alias: indexKR4rDOoNGFMeta?.alias || [],
    redirect: indexKR4rDOoNGFMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/index.vue").then(m => m.default || m)
  },
  {
    name: indexqOV5qkiA0hMeta?.name ?? "sites-url-search",
    path: indexqOV5qkiA0hMeta?.path ?? "/sites/:url()/search",
    meta: indexqOV5qkiA0hMeta || {},
    alias: indexqOV5qkiA0hMeta?.alias || [],
    redirect: indexqOV5qkiA0hMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexJtYT9fGwcEMeta?.name ?? "sites-url-tags",
    path: indexJtYT9fGwcEMeta?.path ?? "/sites/:url()/tags",
    meta: indexJtYT9fGwcEMeta || {},
    alias: indexJtYT9fGwcEMeta?.alias || [],
    redirect: indexJtYT9fGwcEMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/[url]/tags/index.vue").then(m => m.default || m)
  },
  {
    name: indexEcTSAQcYmUMeta?.name ?? "sites",
    path: indexEcTSAQcYmUMeta?.path ?? "/sites",
    meta: indexEcTSAQcYmUMeta || {},
    alias: indexEcTSAQcYmUMeta?.alias || [],
    redirect: indexEcTSAQcYmUMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/sites/index.vue").then(m => m.default || m)
  },
  {
    name: indexGwvY6exWwOMeta?.name ?? "upload",
    path: indexGwvY6exWwOMeta?.path ?? "/upload",
    meta: indexGwvY6exWwOMeta || {},
    alias: indexGwvY6exWwOMeta?.alias || [],
    redirect: indexGwvY6exWwOMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/upload/index.vue").then(m => m.default || m)
  },
  {
    name: index3DnPB0LYycMeta?.name ?? "usage",
    path: index3DnPB0LYycMeta?.path ?? "/usage",
    meta: index3DnPB0LYycMeta || {},
    alias: index3DnPB0LYycMeta?.alias || [],
    redirect: index3DnPB0LYycMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/usage/index.vue").then(m => m.default || m)
  },
  {
    name: indexhzrrHczR6qMeta?.name ?? "usage-manage-organisation-organisationid",
    path: indexhzrrHczR6qMeta?.path ?? "/usage/manage-organisation/:organisationid()",
    meta: indexhzrrHczR6qMeta || {},
    alias: indexhzrrHczR6qMeta?.alias || [],
    redirect: indexhzrrHczR6qMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/usage/manage-organisation/[organisationid]/index.vue").then(m => m.default || m)
  },
  {
    name: indexpTpkqhTGyWMeta?.name ?? "user-settings",
    path: indexpTpkqhTGyWMeta?.path ?? "/user-settings",
    meta: indexpTpkqhTGyWMeta || {},
    alias: indexpTpkqhTGyWMeta?.alias || [],
    redirect: indexpTpkqhTGyWMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/user-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexBvnfDRJevdMeta?.name ?? "version",
    path: indexBvnfDRJevdMeta?.path ?? "/version",
    meta: indexBvnfDRJevdMeta || {},
    alias: indexBvnfDRJevdMeta?.alias || [],
    redirect: indexBvnfDRJevdMeta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/version/index.vue").then(m => m.default || m)
  },
  {
    name: indexeP88q9sA34Meta?.name ?? "welcome",
    path: indexeP88q9sA34Meta?.path ?? "/welcome",
    meta: indexeP88q9sA34Meta || {},
    alias: indexeP88q9sA34Meta?.alias || [],
    redirect: indexeP88q9sA34Meta?.redirect,
    component: () => import("/opt/apps/transkribus_app_beta/pages/welcome/index.vue").then(m => m.default || m)
  },
  {
    name: component_45stubBMljg2BvY4Meta?.name ?? undefined,
    path: component_45stubBMljg2BvY4Meta?.path ?? "/home",
    meta: component_45stubBMljg2BvY4Meta || {},
    alias: component_45stubBMljg2BvY4Meta?.alias || [],
    redirect: component_45stubBMljg2BvY4Meta?.redirect,
    component: component_45stubBMljg2BvY4
  }
]